module.exports = __webpack_public_path__ + "static/media/titan_aviation_logo.937096d6.svg";